// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Bf74q-Response-module_root{display:flex;flex-direction:column;align-items:center;justify-content:center}.WjYIb-Response-module_icon{margin-bottom:1.6666666667rem}.adTKI-Response-module_info{gap:.6666666667rem}.aH7_V-Response-module_error,.adTKI-Response-module_info{display:flex;flex-direction:column;align-items:center;justify-content:center}.aH7_V-Response-module_error{gap:.5rem;margin-top:3.3333333333rem}.fo8XB-Response-module_title{text-align:center}.FauXU-Response-module_button{width:18.3333333333rem;margin-top:1.6666666667rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Bf74q-Response-module_root",
	"icon": "WjYIb-Response-module_icon",
	"info": "adTKI-Response-module_info",
	"error": "aH7_V-Response-module_error",
	"title": "fo8XB-Response-module_title",
	"button": "FauXU-Response-module_button"
};
export default ___CSS_LOADER_EXPORT___;
